/**
 * These utilities provide a stable API for interacting with the various platform-specific
 * clipboard APIs.
 * execCommand('copy') isn't supported in Safari
 * The clipboard-write permission name is not currently supported in Firefox
 * The Clipboard API is not supported in IE
 * https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Interact_with_the_clipboard
 */

const copyWithExecCommand = (element) =>
    new Promise((resolve, reject) => {
        element.select();
        const execCopied = document.execCommand('copy');
        if (!execCopied) {
            reject();
            return;
        }

        resolve();
    });

const copyWithClipboardAPI = (value) =>
    window.navigator.clipboard.writeText(value);

const defaultValueGetter = (element) => element.innerText;

export const copy = (element, valueGetter = defaultValueGetter) => {
    // mobile safari window.navigator.clipboard is undefined
    // IE does not implement window.navigator.clipboard.writeText
    const supportsWriteText =
        window.navigator.clipboard && window.navigator.clipboard.writeText;
    if (supportsWriteText) {
        return copyWithClipboardAPI(valueGetter(element)).catch(
            () => copyWithExecCommand(element), // Fall through to the backup option
        );
    }
    // At this point, we're dealing with IE and
    // must use the document.execCommand interface
    return copyWithExecCommand(element);
};

export const clearSelection = () => {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
};
